import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import pagerArrowSVG from '~/images/pager-arrow.svg';

const Pager = ({ totalCount, itemsPerPage, activePage }) => {
	const location = useLocation();
	const [pages, setPages] = useState([]);
	const activePageNumber = Number(activePage);
	const totalPageCount = Math.ceil(totalCount / itemsPerPage);

	useEffect(() => {
		const composePages = () => {
			let pagesArray = [];
			for (let i = 0; i < totalCount / itemsPerPage; i++) {
				let page = i + 1;
				pagesArray.push(page);
			}

			const pageCount = pagesArray.length;

			if (pageCount <= 5) {
				setPages(pagesArray);
				return;
			}

			if (activePageNumber === 1) {
				pagesArray = [1, 2, 3, 0, pageCount];
			} else if (activePageNumber === pageCount) {
				pagesArray = [1, 0, pageCount - 2, pageCount - 1, pageCount];
			} else if (pageCount - activePageNumber < activePageNumber - 1) {
				pagesArray = [1, 0, activePageNumber - 1, activePageNumber, activePageNumber + 1];
			} else if (pageCount - activePageNumber >= activePageNumber - 1) {
				pagesArray = [activePageNumber - 1, activePageNumber, activePageNumber + 1, 0, pageCount];
			}

			setPages(pagesArray);
		};

		composePages();
	}, [activePage, itemsPerPage, totalCount, activePageNumber]);

	const buildPageUrl = pageNumber => {
		const urlSearchParams = new URLSearchParams(location.search);

		urlSearchParams.delete('page');

		// Add the new page number (only if it's not page 1, to keep URLs clean)
		if (pageNumber > 1) {
			urlSearchParams.set('page', String(pageNumber));
		}

		const queryString = urlSearchParams.toString();
		return `${location.pathname}${queryString ? `?${queryString}` : ''}`;
	};

	if (itemsPerPage >= totalCount) return null;

	return (
		<ul id="pager" className="flex-col">
			{activePageNumber > 1 ? (
				<li className="arrow back">
					<a href={buildPageUrl(activePageNumber - 1)} aria-label="Go to previous page" rel="prev">
						<img src={pagerArrowSVG} alt="pager arrow back" />
					</a>
				</li>
			) : (
				<li className="arrow"></li>
			)}
			{pages.map(page => (
				<li key={page} className={activePageNumber === page ? 'active' : undefined}>
					{page !== 0 ? (
						<a href={buildPageUrl(page)} aria-label={`Go to page ${page}`}>
							{page}
						</a>
					) : (
						<span className="dots">...</span>
					)}
				</li>
			))}
			{activePageNumber < totalPageCount ? (
				<li className="arrow front">
					<a href={buildPageUrl(activePageNumber + 1)} aria-label="Go to next page" rel="next">
						<img src={pagerArrowSVG} alt="pager arrow front" width={8} height={13} loading="lazy" />
					</a>
				</li>
			) : (
				<li className="arrow"></li>
			)}
		</ul>
	);
};

Pager.propTypes = {
	totalCount: PropTypes.number,
	itemsPerPage: PropTypes.number,
	searchParams: PropTypes.any,
	setSearchParams: PropTypes.any,
	activePage: PropTypes.any
};

export default Pager;
